import React, { Component } from 'react';

class PrivacyPolicyBanner extends Component {

  render() {
    return (
      <div className="banner contact layui-container">
        <div className="title">
          <p>個人情報保護方針</p>
          <p className="en">Privacy Policy</p>
        </div>
      </div>
    )
  }
}

export default PrivacyPolicyBanner
